import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'
import { clearModal } from '@hixme/modal'
import { BENEFIT_TYPE_BASIC_LIFE } from '@hixme/benefit-types'

// project
import DeclineCoverageModal from 'components/DeclineCoverageModal'
import { createErrorNotification } from 'modules/notification-manager/actions'

// store
import cart from 'store/modules/cart'

const mapStateToProps = (state, { data }) => ({
  coveredPersons: data.persons,
  benefitProducts: [data.benefit],
  isProcessing:
    getWaiter(state, cart.constants.getBenefitPath(BENEFIT_TYPE_BASIC_LIFE)).isPending || false,
})

const mapDispatchToProps = (dispatch) => ({
  onDeclineClick: (coveredPersons, [benefit]) => {
    dispatch(cart.actions.declineBenefit(BENEFIT_TYPE_BASIC_LIFE, coveredPersons, benefit)).then(
      () => {
        dispatch(clearModal())
      },
      () => {
        dispatch(clearModal())
        dispatch(createErrorNotification('There was an error declining vision. Please try again.'))
      }
    )
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeclineCoverageModal)
